import React, { Component } from 'react';
import { ErrorMessage, Field, getIn } from 'formik';
import DatePicker from 'react-datepicker';
import * as moment from 'moment';
import { requiredValidation } from './fieldValidateUtil';
import { FieldTypes, timeSlotPicker } from 'drapcode-constant';
import PlaceholderFieldsModal from '../../../../common/ui/PlaceholderFieldsModal.js';
import { toast } from 'react-toastify';
const { time_picker } = FieldTypes;

const PLACEHOLDER_FIELDS_DATA = {
  defaultCategory: 'meta-fields',
  categories: [
    {
      name: 'meta-fields',
      title: 'Meta Fields',
      icon: 'meta-fields',
      fields: [
        {
          name: 'CURRENT_DATE_TIME',
          title: 'Current Date Time',
        },
      ],
    },
  ],
};
const CONSTANT_VALUES = PLACEHOLDER_FIELDS_DATA.categories[0].fields.map(
  (field) => `{{${field.name}}}`,
);
class DateTimeField extends Component {
  state = {
    showModalForMetaFields: false,
  };
  validate = (value) => {
    if (this.props.isConstructorForm) {
      if (value && this.isMetaFieldPlaceholder(value)) return;

      if (value && typeof value === 'string' && isNaN(Date.parse(value))) {
        return 'Please select a valid date or use a meta field constant';
      }
    }
    return requiredValidation(value, this.props.field);
  };

  toggleMetaFieldsModal = () => {
    this.setState({ showModalForMetaFields: !this.state.showModalForMetaFields });
  };

  copyToClipboard = () => {
    this.setState({
      copied: true,
      showModalForMetaFields: !this.state.showModalForMetaFields,
    });
    toast.success('Copied to clipboard');
    setTimeout(() => {
      this.setState({ copied: false });
    }, 2000);
  };

  insertTextToParamInput = (textToInsert) => {
    if (textToInsert) {
      const currentValue = this.props.values[this.props.field.fieldName] || '';
      const newValue = `${textToInsert}`;
      this.props.setFieldValue(this.props.field.fieldName, newValue);
      this.setState({ showModalForMetaFields: false });
      toast.success('Inserted into Input Field');
    }
  };

  showCollectionMetaFieldModal = () => {
    const { collections } = this.props;
    return (
      <PlaceholderFieldsModal
        copyToClipboard={this.copyToClipboard}
        insertTextToEditor={this.insertTextToParamInput}
        toggleFields={this.state.showModalForMetaFields}
        toggleFieldsModal={this.toggleMetaFieldsModal}
        fieldsData={PLACEHOLDER_FIELDS_DATA}
        collections={collections}
        excludeFields={['current_user', 'session']}
      />
    );
  };

  isMetaFieldPlaceholder = (value) => {
    return typeof value === 'string' && CONSTANT_VALUES.includes(value);
  };

  handleChange = (date) => {
    const { field, projectDetail } = this.props;
    let isShowDateOnly =
      field.extraFieldSetting &&
      ['date', 'date-segregated'].includes(field.extraFieldSetting.dateDisplayType);
    if (timeSlotPicker.includes(field.type)) {
      isShowDateOnly = false;
    }
    const isTimepicker = field.type === time_picker.id;
    if (isShowDateOnly) {
      const selectedDate = new Date(date);
      this.props.setFieldValue(field.fieldName, moment(selectedDate).format('YYYY-MM-DD'));
    } else {
      if (isTimepicker) {
        date = date ? moment(date).format('HH:mm') : '';
      } else {
        date = date ? moment(date).format('YYYY-MM-DDTHH:mm:ss') : '';
      }
      this.props.setFieldValue(field.fieldName, date);
    }
  };

  render() {
    const { field, values, projectDetail, isConstructorForm } = this.props;
    const { dateFormat } = projectDetail || {};
    const dateFieldValue = getIn(values, field.fieldName);

    let isShowDateOnly =
      field.extraFieldSetting &&
      ['date', 'date-segregated'].includes(field.extraFieldSetting.dateDisplayType);
    let isShow24Hours =
      field.extraFieldSetting && field.extraFieldSetting.dateDisplayType === '24_HOURS';
    if (timeSlotPicker.includes(field.type)) {
      isShowDateOnly = false;
    }
    const isTimepicker = field.type === time_picker.id;
    const isPlaceholder = this.isMetaFieldPlaceholder(dateFieldValue);
    const metaModalDisplay = isConstructorForm && !isTimepicker;

    return (
      <>
        {this.state.showModalForMetaFields &&
          metaModalDisplay &&
          this.showCollectionMetaFieldModal()}
        {isPlaceholder ? (
          <Field
            type={'text'}
            name={field.fieldName}
            className="form-control form-control-sm"
            placeholder={field.placeholder['en']}
            autoComplete="off"
            title={field.fieldTitle['en']}
          />
        ) : (
          <DatePicker
            validate={this.validate}
            selected={(() => {
              if (!dateFieldValue) return null;
              try {
                if (isTimepicker) {
                  const m = moment(dateFieldValue, 'HH:mm', true);
                  return m.isValid() ? m.toDate() : null;
                } else if (isShowDateOnly) {
                  const m = moment(dateFieldValue, 'YYYY-MM-DD', true);
                  return m.isValid() ? m.toDate() : null;
                } else {
                  const m = moment(dateFieldValue, 'YYYY-MM-DDTHH:mm:ss', true);
                  return m.isValid() ? m.toDate() : null;
                }
              } catch (err) {
                console.error('Date parse error:', err, dateFieldValue);
                return null;
              }
            })()}
            name={field.fieldName}
            showTimeSelect={!isShowDateOnly}
            showTimeSelectOnly={!isShowDateOnly && isTimepicker}
            timeFormat={isTimepicker ? (isShow24Hours ? 'HH:mm' : 'h:mm a') : 'h:mm a'}
            timeIntervals={15}
            timeCaption="Time"
            dateFormat={
              isShowDateOnly
                ? 'MMMM d, yyyy'
                : isTimepicker
                ? isShow24Hours
                  ? 'HH:mm'
                  : 'h:mm a'
                : 'MMMM d, yyyy h:mm aa'
            }
            className="form-control"
            onChange={this.handleChange}
            placeholderText={field.fieldTitle['en']}
            title={field.fieldTitle['en']}
          />
        )}
        {metaModalDisplay && (
          <div className="input-group-append">
            <span className="input-group-text">
              <button
                type="button"
                className="btn btn-theme-submit btn-xs btn-icon-only"
                title="Add Meta Fields"
                onClick={() => {
                  this.toggleMetaFieldsModal();
                }}
              >
                <i className="wb webconnect-plus" />
              </button>
            </span>
          </div>
        )}
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      </>
    );
  }
}

export default DateTimeField;
